import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Navigation extends Component {
    render() {
        const { categoryID, categoryData, soc, isQuizComplete } = this.props;

        return (
            <div className="navigation">
                <div className="row no-gutters">
                    {categoryID === 1 ? (
                        <Link to="/" className="navigation-prev">
                            BACK
                        </Link>
                    ) : (
                        <Link to={`/question/${categoryID - 1}`} className="navigation-prev">
                            BACK
                        </Link>
                    )}
                    
                    {(categoryID == 11 && soc && isQuizComplete) || (categoryData && categoryData.score != null) ? (
                        <Link to={categoryID == 11 ? `/form` : `/question/${categoryID + 1}`} className="navigation-next">
                            NEXT
                        </Link>
                    ) : (
                        <div className="navigation-next __disabled">
                            NEXT
                        </div>
                    )}
                    
                </div>
            </div>
        );
    }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Question/Navigation.js